import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking"
import { GDPRSdk } from "@ciaopeople/cp-shatsu/GDPR";
import { MediaLoadedEvent } from "../../events/PlayerEvent.js";
import { isMediaMetaData, YM_Category } from "../../../model/MediaMetaData.js";

export type NielsenTrackingIdMapping = {
    default: string,
    categorized?: {[k in YM_Category]: string}
}


 
type NielsenCmd = "setPlayheadPosition" | "stop" | "loadMetadata" | "end"


type NielsenAirDate = string

type NielsenMetadataPlayload = {
    type: "content",
    assetid: string,
    program: string,
    title: string,
    length: number,
    airdate: NielsenAirDate,
    isfullepisode: "y" | "n",
    adloadtype: "2" //what are the possible values?

}

interface NielsenSdk {

    ggPM(cmd: NielsenCmd, data: number | NielsenMetadataPlayload): void
}

interface WithNLSQueue {

    NOLBUNDLE: {
        nlsQ(e: string,o: string,c?: any,r?: any,s?: any,i?: any): NielsenSdk
    }
}

function isWithNLSQueue(x: any): x is WithNLSQueue {
    return x && "NOLBUNDLE" in x && x.NOLBUNDLE && 
            ("nlsQ" in x.NOLBUNDLE) && isFunction(x.NOLBUNDLE.nlsQ);
}



function initNLSQueue(w: Window): WithNLSQueue {
    if(isWithNLSQueue(w)) return w;
    else {
        const q = function(t,n)
        {
            t[n]=t[n]||
                {
                    nlsQ:function(e,o,c,r,s,i)
                    {
                        return s=t.document,
                            r=s.createElement("script"),
                            //r.async=1,
                            r.defer = 1,
                            r.src=("http:"===t.location.protocol?"http:":"https:")+"//cdn-gl.imrworldwide.com/conf/"+e+".js#name="+o+"&ns="+n,
                            i=s.getElementsByTagName("script")[0],
                            i.parentNode.insertBefore(r,i),
                            t[n][o]=t[n][o]||{g:c||{},
                                    ggPM:function(e,c,r,s,i){(t[n][o].q=t[n][o].q||[]).push([e,c,r,s,i])}},t[n][o]
                    }
                }
        };
        q(w,"NOLBUNDLE");
        return w as unknown as WithNLSQueue;
    }


}


export class NielsenCollectorFactory {


    

    constructor(private window: Window,
                private trackingIdMapping: NielsenTrackingIdMapping,
                private playerName: string,
                private gdprPromise: Promise<GDPRSdk>
                ) {

    }



    public getCollector(mle: MediaLoadedEvent): Promise<NielsenCollector> {
        const trackinId = mle.info.meta?.category && this.trackingIdMapping.categorized &&
            (mle.info.meta.category in this.trackingIdMapping.categorized)?
                this.trackingIdMapping.categorized[mle.info.meta.category]:
                this.trackingIdMapping.default;

        return this.gdprPromise.then(gdpr => {
            // Stato del consenso all'SDK Video Nielsen (Legacy) — 3 stati (Doc A §2/§3/§5):
            //   "Y" consenso prestato   -> init con optout="false" (rilevazione completa + cookie)
            //   "N" consenso negato     -> init con optout="true"  (solo rilevazione volumetrica)
            //   "O" opt-out volumetrica -> NON avviare l'istanza SDK (nessuna rilevazione)
            // Opt-out da volumetricEnabled(), consenso da videoNieslenEnabled() (refuso del SDK).
            const consent = !gdpr.audicom.volumetricEnabled() ? "O"
                : (gdpr.audicom.videoNieslenEnabled() ? "Y" : "N");

            // Doc A §5: in opt-out il Cliente deve astenersi dall'avviare l'istanza SDK.
            if (consent === "O") {
                console.log("[NIELSEN] Opt-out volumetrica: istanza SDK Video Nielsen non avviata per", mle.info.id);
                return new NielsenCollector(null, mle);
            }

            // Doc A §3: optout="false" con consenso, "true" in assenza di consenso esplicito.
            // (nol_sdkDebug: "debug" va aggiunto solo per le build di debug.)
            const optout = consent === "Y" ? "false" : "true";
            console.log(`[NIELSEN] SDK Video Nielsen avviato (consenso=${consent}, optout="${optout}") per`, mle.info.id);
            const sdk = initNLSQueue(this.window).NOLBUNDLE.nlsQ(trackinId, this.playerName, { optout : optout });
            return new NielsenCollector(sdk, mle);
        });
    }

   


}

function tc(num: number): string {
    return Math.floor(num).toString().padStart(2,'0');
}

function dateToAirDate(d: Date): string {
    return `${d.getUTCFullYear()}${tc(d.getUTCMonth()+1)}${tc(d.getUTCDate())} ${tc(d.getUTCHours())}:${tc(d.getUTCMinutes())}:${tc(d.getUTCSeconds())}`;
}



const COLLECTOR_RESOLUTION_IN_SECONDS = 1;



type NielsenCollectorState =  "init" | "started" | "paused" | "ended";
/**
 * actually, as for main site and older player nielsen is not subject to gdpr
 */
export class NielsenCollector {



    private enabled: boolean;
    private state: NielsenCollectorState;
    
    private meta: NielsenMetadataPlayload;
    private lastPushedTime: number;
    
    constructor(private sdk: NielsenSdk | null,
                private mle: MediaLoadedEvent
               ) {
        this.lastPushedTime = 0;
        this.state = "init";
        
        if(sdk && mle.info.meta && isMediaMetaData(mle.info.meta)) {
            const duration = mle.metadata?.duration?mle.metadata.duration:(mle.info.meta?.duration?mle.info.meta?.duration:0);
            this.enabled = true;
            console.log("VIDEOMETA",this.mle.info.meta);
            this.meta = {
                type: "content",
                assetid: this.mle.info.id,
                program: this.mle.info.title.substring(0,100),
                title: this.mle.info.title.substring(0,100),
                length: Math.floor(duration),
                airdate: dateToAirDate(new Date(this.mle.info.meta.publish_stamp?this.mle.info.meta.publish_stamp:0)),
                isfullepisode: "y",
                adloadtype: "2"

            }
        }
        else {
            this.enabled = false;
            this.meta = null;
            console.log("NIELSEN not enabled on item", this.mle.info.id, "missing meta");
        }
    }


    public timeupdate(time: number): void {
        if(this.sdk && this.enabled && this.state == "started") {
            const sanitime = Math.floor(time);
            if(sanitime - this.lastPushedTime >= COLLECTOR_RESOLUTION_IN_SECONDS) {
                this.lastPushedTime = sanitime;
                this.sdk.ggPM("setPlayheadPosition",sanitime)
            }
        
        }
    }


    public play(): void {
        if(this.sdk && this.enabled && (this.state == "init" || this.state == "paused")) {
            this.state = "started";
            this.sdk.ggPM("loadMetadata", this.meta);
        }
    }


    public pause(): void {
        if(this.sdk && this.enabled && this.state == "started") {
            this.state = "paused";
            this.sdk.ggPM("stop",this.lastPushedTime)
        }
    }

    public complete(): void {
        if(this.sdk && this.enabled && (this.state == "started" || this.state == "paused")) {
            this.state = "ended";
            this.sdk.ggPM("end",this.lastPushedTime);
        }
    }


    get currentState(): NielsenCollectorState {
        return this.state;
    }

}